import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '@/components/shared/Seo';
import { combineSchemas, organizationSchema, websiteSchema, webPageSchema, breadcrumbSchema } from '@/lib/schemaOrg';

const NotFoundPage = () => (
  <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-4" data-testid="not-found-page">
    <Seo
      title="Page not found (404) | Winhouse Tutors"
      description="The page you are looking for does not exist. Explore tutors, IELTS, VCE, PTE, TOEFL, SAT, GMAT, GRE and study-abroad guidance instead."
      path="/404"
      noindex
      jsonLd={combineSchemas(
        organizationSchema(),
        websiteSchema(),
        webPageSchema({ title: 'Page not found', description: '404 page', path: '/404' }),
        breadcrumbSchema([{ name: '404', path: '/404' }])
      )}
    />
    <div className="max-w-lg text-center">
      <div className="text-[10px] uppercase tracking-[0.25em] text-red-700 font-bold">Winhouse Tutors</div>
      <div className="mt-3 text-6xl font-black text-black">404</div>
      <h1 className="mt-2 text-2xl font-bold">We couldn&rsquo;t find that page.</h1>
      <p className="mt-3 text-sm text-gray-600">
        The link may be outdated or mistyped. Head back to our homepage or pick a popular destination below.
      </p>
      <div className="mt-6 grid grid-cols-2 gap-2">
        {[
          ['Find a Tutor', '/tutors'],
          ['Get Started', '/get-started'],
          ['IELTS Preparation', '/ielts'],
          ['VCE Tutoring', '/vce'],
          ['Study Abroad', '/study-abroad'],
          ['Blog', '/blog'],
        ].map(([lbl, href]) => (
          <Link key={href} to={href}
            className="h-11 rounded-full bg-black hover:bg-gray-800 text-white text-xs font-black uppercase tracking-wider inline-flex items-center justify-center"
            data-testid={`404-link-${href.replace(/\W+/g, '-')}`}>
            {lbl}
          </Link>
        ))}
      </div>
    </div>
  </div>
);

export default NotFoundPage;
